import { render, staticRenderFns } from "./tiscTable.vue?vue&type=template&id=f6ff1270&"
import script from "./tiscTable.vue?vue&type=script&lang=js&"
export * from "./tiscTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports